/**
 * 改密碼（P1.5-A；`decisions/015` §2.2）
 *
 * ⭐ 由右上角 ⚙ 選單入（唔上 tab）—— 三個角色都用得。
 * 後端 `POST /api/auth/password`：**一定要驗舊密碼**；改完**撤銷自己其他 session**
 * （呢個裝置留住，唔使即刻再登入）。
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { btnPrimary, card, errText, hint as hintStyle, input, label } from '@coeldery/ui-kit';
import { ApiError, api } from '../lib/api';

export default function ChangePassword() {
  const { t } = useTranslation();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const submit = async () => {
    setError(null);
    if (next !== confirm) {
      setError(t('pwd.mismatch'));
      return;
    }
    setBusy(true);
    try {
      await api.changePassword(current, next);
      setDone(true);
      setCurrent('');
      setNext('');
      setConfirm('');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t('common.loadFailed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <h2 style={{ margin: '0 0 6px', fontSize: '18px', fontWeight: 800 }}>{t('pwd.title')}</h2>
      <p style={hintStyle}>{t('pwd.intro')}</p>

      <section style={{ ...card, padding: '16px', marginTop: '12px' }}>
        <div style={{ marginBottom: '12px' }}>
          <label style={label} htmlFor="pwd-current">
            {t('pwd.current')}
          </label>
          <input
            id="pwd-current"
            type="password"
            autoComplete="current-password"
            style={input}
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: '12px' }}>
          <label style={label} htmlFor="pwd-next">
            {t('pwd.next')}
          </label>
          <input
            id="pwd-next"
            type="password"
            autoComplete="new-password"
            style={input}
            value={next}
            onChange={(e) => setNext(e.target.value)}
          />
          <p style={hintStyle}>{t('pwd.policy')}</p>
        </div>

        <div style={{ marginBottom: '12px' }}>
          <label style={label} htmlFor="pwd-confirm">
            {t('pwd.confirm')}
          </label>
          <input
            id="pwd-confirm"
            type="password"
            autoComplete="new-password"
            style={input}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
        </div>

        {error && (
          <p style={errText} role="alert">
            {error}
          </p>
        )}
        {done && <p style={{ ...hintStyle, fontWeight: 700, color: 'var(--color-primary)' }}>{t('pwd.done')}</p>}

        <button
          type="button"
          style={btnPrimary}
          onClick={() => void submit()}
          disabled={busy || !current || !next}
        >
          {busy ? t('common.saving') : t('pwd.submit')}
        </button>
        <p style={{ ...hintStyle, marginTop: '10px' }}>
          <Link to="/" style={{ fontWeight: 700 }}>
            {t('pwd.back')}
          </Link>
        </p>
      </section>
    </>
  );
}
